import Link from "next/link";
import { FadeIn, HomeEyebrow, HomeHeading, HomeLead, HomeSection } from "~/components/siteglue/home/section-shell";
import { AUDIT_SERVICE_PAGES } from "~/lib/siteglue/audits/catalog";

export function HomeOptimizationServices() {
  return (
    <HomeSection tone="slate" className="py-16 sm:py-20">
      <FadeIn>
        <HomeEyebrow>Optimization services</HomeEyebrow>
        <HomeHeading>Get recommended. Get discovered. Get customers.</HomeHeading>
        <HomeLead>
          SiteGlue Agent is one product. AEO, ARO, and CRO are the optimization services around it —
          not three separate AI Agent products.
        </HomeLead>
      </FadeIn>
      <div className="mt-10 grid gap-4 md:grid-cols-3">
        {AUDIT_SERVICE_PAGES.map((page, index) => (
          <FadeIn key={page.slug} delay={0.05 * (index + 1)}>
            <Link
              href={page.href}
              className="flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-6 hover:border-slate-300"
            >
              <p className="text-xs font-semibold uppercase tracking-[0.14em] text-[#4f81bd]">{page.eyebrow}</p>
              <h2 className="mt-3 text-xl font-semibold text-slate-900">{page.headline}</h2>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600">{page.description}</p>
              <span className="mt-5 text-sm font-semibold text-[#4f81bd]">{page.ctaLabel}</span>
            </Link>
          </FadeIn>
        ))}
      </div>
    </HomeSection>
  );
}
